import {
	VehicleCategoryFeatureItemDto,
	VehicleCategoryFeatureItemTypeEnum,
	VehicleFeatureItemDto,
} from '@splitsecondconnect/ultramarine-shared';

import { FeatureItemModel } from '../models/feature-item.model';
import { SelectItem } from '../models/select-item.type';

export function mapFeatureItemDtoToFeatureItemModel(
	x: VehicleFeatureItemDto[] | VehicleCategoryFeatureItemDto[],
): {
	featureItems: FeatureItemModel[];
} {
	if (!x) {
		return {
			featureItems: null,
		};
	}

	const featureItems: FeatureItemModel[] = [];

	x.forEach((item) => {
		featureItems.push({
			id: item.id,
			uuid: item.uuid,
			title: item.title,
			key: item.key,
			value: item.value,
			valueType: item.valueType,
		});
	});

	return { featureItems: featureItems };
}

export function mapFeatureItemModelsToSelectItems(
	featureItems: FeatureItemModel[],
): SelectItem<string>[] {
	if (!featureItems?.length) {
		return [];
	}
	return featureItems.map((item) => ({
		value: item.uuid,
		displayValue: item.title ?? item.key,
	}));
}

export function mapFeatureItemModelsToFeatureItemDtos(
	model: FeatureItemModel[] | null | undefined,
): { featureItems: VehicleCategoryFeatureItemDto[] | null } {
	if (!model?.length) {
		return { featureItems: null };
	}
	const featureItems: VehicleCategoryFeatureItemDto[] = model.map((item) => ({
		id: item.id,
		uuid: item.uuid,
		key: item.key,
		title: item.title,
		value: item.value,
		valueType: item.valueType,
		type: VehicleCategoryFeatureItemTypeEnum.VEHICLE_CATEGORY_EXTRA,
	}));
	return { featureItems };
}
